import { render, staticRenderFns } from "./rate-editor.vue?vue&type=template&id=e5255a1c"
import script from "./rate-editor.vue?vue&type=script&lang=js"
export * from "./rate-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports